import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, of as observableOf, of, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { DatetimeToString } from 'src/app/core/pipe/pipe-datetime';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { LeadStatus } from '../../models/leadStatus';
import { RequestStatus } from '../../models/requestStatus';
import { LeadService } from '../../services/lead.service';
import { RequestService } from '../../services/request.service';
import { AbstractForm } from '../../utils/abstract-form';
import { Pagination } from '../../utils/pagination';
import { AdminController } from 'src/app/modules/admin/admin.controller';

declare var $: any;

@Component({
    selector: 'app-leads',
    templateUrl: './leads.component.html',
    styleUrls: ['./leads.component.scss']
})
export class LeadsComponent extends AbstractForm implements AfterViewInit, OnDestroy {

    dialogRef: MatDialogRef<any>;

    params: any = {};
    title: any = '';
    id: any = '';

    filterStatusOptions = new LeadStatus().getOptions();

    filter = {
        status: this.filterStatusOptions,
        type: [
            { id: 1, title: 'Acesso restrito' },
            { id: 2, title: 'Material físico' },
            { id: 3, title: 'Autorização de venda' }
        ],
        sort: [
            { id: 'recent', title: 'Adicionaram à favoritos recentemente', default: true }
            , { id: 'alphabetical', title: 'Ordem alfabética' }
        ]
    };


    iconStatus: any = new LeadStatus().getIcons();

    filterSelected: any = {
        status: this.filter.status.filter(item => item.default),
        sort: this.filter.sort.filter(item => item.default),
        text: ''
    };

    filterMatchSelected: any = {};

    companieSelData: any = {};

    @ViewChild(MatPaginator) paginator: MatPaginator;

    listLoading = false;
    displayedColumns: string[] = ['status', 'name', 'contact', 'message', 'source', 'date', 'action'];
    columnsToDisplay: string[] = this.displayedColumns.slice();

    data: MatTableDataSource<any> = new MatTableDataSource<any>();

    resultsLength = 0;
    isRateLimitReached = false;

    loadingList = true;

    owner_person_id = false;

    protected companieSelSubscription: Subscription;
    protected transactionSubscription: Subscription;

    constructor(
        protected als: AppLoadingService,
        public dialog: MatDialog,
        protected httpService: HttpService,
        protected gs: GeneralService,
        protected rs: RequestService,
        protected router: Router,
        protected formBuilder: FormBuilder,
        protected activatedRoute: ActivatedRoute,
        protected ld: LeadService,
        private control: AdminController,
        logger: LoggerService) {

        super(formBuilder, logger, true);

        if (this.activatedRoute.snapshot.data['owner_person_id'] && this.gs.getProfiledata()?.perfil_id == '1')
            this.owner_person_id = this.activatedRoute.snapshot.data['owner_person_id'];

        this.transactionSubscription = this.gs.transactionData.subscribe(result => {
            if (['leads'].indexOf(result?.method) > -1 && result?.action == 'reloadData') {
                this.refresh();
                this.gs.transactionData.next(null);
            }
        });

    }

    ngAfterViewInit(): void {

        this.companieSelSubscription = this.gs.companiesSel$.subscribe(result => {
            this.companieSelData = document.location.pathname.indexOf('realtor') > -1 ? this.gs.getProfiledata() : this.gs.getCompanieData(result);

            if (!this.owner_person_id && this.companieSelData?.company_person_id)
                this.owner_person_id = this.companieSelData?.company_person_id;

            this.refresh();
        });

        this.getControl('filter').valueChanges
            .pipe(
                //filter(text => text.trim().length >= 3),
                debounceTime(350),
                distinctUntilChanged())
            .subscribe(value => {
                if (value.trim().length >= 3) {
                    this.filterSelected.text = value;
                    this.refresh();
                } else if (this.filterSelected.text != '') {
                    this.filterSelected.text = '';
                    this.refresh();
                }

            });
    }

    ngOnDestroy() {
        this.companieSelSubscription?.unsubscribe();
        this.transactionSubscription?.unsubscribe();
    }

    buildFormGroup(): FormGroup {

        return this.formBuilder.group({
            filter: ['', [Validators.required, Validators.minLength(3)]]
        });

    }
    updateControls() { }
    updateObject(): any { }
    //'status', 'source'('source_action'), 'name' ('email','phone'), 'message', 'date'
    getColumnHeader(columnName: string) {
        switch (columnName) {
            case 'status':
                return 'Status';
            case 'source':
                return 'Origem';
            case 'message':
                return 'Mensagem / Anexos';
            case 'date':
                return 'Recebido em';
        }
    }


    getColumnRowValue(element: any, columnName: string) {
        switch (columnName) {
            case 'ad':
                return element['ad_title'];
            case 'date':
                var datePipe = new DatetimeToString();
                return datePipe.transform(element['creation']);
            default:
                return element[columnName];
        }
    }


    clickOnCell(event, column, data) {
    }

    refresh() {
        this.listLoading = true;
        this.paginator.firstPage();

        merge(this.paginator.page)
            .pipe(
                startWith({}),
                switchMap(() => {
                    this.als.setLoaded(false, 'requestListLoad');
                    return this.loadData(20, this.paginator.pageIndex + 1);
                }),
                map((data: any) => {
                    this.als.setLoaded(true, 'requestListLoad');
                    this.resultsLength = data.total.value;
                    this.listLoading = false;
                    this.isRateLimitReached = !data.list?.length;

                    data.list = data.list.map(item => {
                        item = this.adjustItem(item);
                        return item;
                    });



                    return data.list;
                }),
                catchError((err) => {
                    console.log(err);
                    this.als.setLoaded(true, 'requestListLoad');
                    this.isRateLimitReached = true;
                    this.listLoading = false;
                    return observableOf([]);
                }))
            .subscribe(data => {
                this.data.data = data;

                setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                    });
                }, 200);
            });
    }



    async loadData(len = 20, page = 0, attr: any = {}) {

        let status = [];
        this.filterSelected.status.map(item => status.push(item.id));

        let text = this.filterSelected.text || false;

        return this.httpService.post<any>(API.general.lead.list, {
            ...(this.owner_person_id ? { owner_person_id: this.owner_person_id } : {}),
            current_page: page,
            filters: {
                ...(!!status?.length ? { status: status } : {}),
                ...(text ? { contains: '%' + text + '%' } : {})
            }
        })
            .then(result => {
                result.list = result.list.map(item => {
                    item.cellphoneMask = item?.cellphone ? this.gs.getPhone(item.cellphone) : null;
                    if (this.id)
                        item.owner_person_id = this.companieSelData;

                    item.icon = new LeadStatus().getIcon(item.source);
                    item.acronym = this.gs.getAcronym(item?.name || '-');
                    item.statusObj = new LeadStatus().getStatus(item.status) || {};

                    if (item?.attachments)
                        item.attachments = this.attachments(item.attachments);

                    //item.acronymColor = this.stringToHslColor(name, 78, 70);
                    //item.acronymTextColor = this.contrastColor(item.acronymColor);
                    return item;
                })

                return result;
            })
            .catch((err) => {
                this.gs.error(err);
            })
            .finally(() => {
                this.loadingList = false;
            });
    }

    attachments(list: any) {
        list = JSON.parse(list);


        list = list.map(item => {

            try {
                let filename: any = item.substr(item.lastIndexOf('/') + 1);
                let date = filename.substr(0, 10);
                let sizestart = filename.substr(11);
                let size = sizestart.substr(0, sizestart.indexOf('_'));
                let name = sizestart.substr(sizestart.indexOf('_') + 1);
                let extension = name.substr(name.lastIndexOf('.') + 1);

                return {
                    file: item,
                    name: name,
                    extension: extension,
                    date: date,
                    size: size
                };
            } catch (e) {
                console.log(e);
            }


        });


        return list;
    }




    imageError(ev, data) {
        data.avatarError = true;
    }
    imgDidLoad(event) {
        this.gs.imgDidLoad(event);
    }


    adjustItem(item: any) {

        item.owner_person_id = this.companieSelData?.company_person_id;

        item.avatar = this.gs.adjustAvatarFiles({ avatar: item.creator_avatar });
        item.avatarFiles = this.gs.getAvatarFile(item.avatar);

        if (item?.ad_cover || item?.cover) {
            item.cover = typeof item?.cover === 'string' ? JSON.parse(item.cover) : (typeof item?.ad_cover === 'string' ? JSON.parse(item.ad_cover) : (item?.ad_cover || item?.cover));
            item.cover = this.gs.getAvatarFile(item.cover);
        }

        if (typeof item?.creator_avatar === 'string' && item?.creator_avatar != '{}')
            item.creatorFiles = this.gs.getAvatarFile(JSON.parse(item.creator_avatar));

        if (typeof item?.owner_avatar === 'string' && item?.owner_avatar != '{}')
            item.ownerFiles = this.gs.getAvatarFile((item.owner_avatar));

        if (typeof item?.payload === 'string' && item?.payload != '{}')
            item.payload = JSON.parse(item.payload);

        if (item.type_id == '3') {
            if (item.authorization_expiration === null && item.status == '2') {
                item.authorization_expire = 'indeterminado';
            } else if (item?.authorization_expiration) {
                let od = new Date(item.authorization_expiration + ' 00:03:00');
                let nd = new Date();

                item.authorization_expire = Math.floor((od.getTime() - nd.getTime()) / 1000 / 60 / 60 / 24);
            }
        }

        return item;
    }

    applyFilter(event, filterItem, tab, clear = false) {
        if (event && !clear)
            event?.stopPropagation();

        if (filterItem == 'all')
            this.filterSelected[tab] = this.filter[tab];
        else {
            if (!this.filterSelected[tab].filter(item => item.id == filterItem.id)?.length) {
                if (clear)
                    this.filterSelected[tab] = [filterItem];
                else
                    this.filterSelected[tab].push(filterItem);
            } else
                this.filterSelected[tab] = this.filterSelected[tab].filter(item => item.id != filterItem.id);
        }
        this.refresh();
    }


    closeDropdown(ev) {
        this.gs.closeDropdown(ev);
    }

    openDropdown(event: MouseEvent) {
        this.gs.openDropdown(event);
    }

    async setAction(event, item, action) {
        this.ld.setAction(event, item, action, this.owner_person_id || false);
    }


    fileAction(event, item, action) {
        event?.stopPropagation();
        switch (action) {
            case 'copy':
                this.gs.copyText(item.file);
                break;
            case 'open':
                window.open(item.file, '_system', 'location=yes');
                break;
        }
    }

}



export class RequestList {
    list: any[];
    total: Pagination;
}
